<template>
  <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs4 v-for="(stat, index) in stats" :key="index">
        <v-card class="text-xs-center" height="100%" :to="stat.link">
          <v-card-text>
            <div class="display-1 mb-2">
              <b v-if="!isLoading">{{ stat.count }}</b>
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
                v-if="isLoading"
              ></v-progress-circular>
            </div>
            {{ stat.title }}
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    
    <v-divider class="mt-4"></v-divider>
    <DateFilter @date:changed="refreshAnalytics" class="mt-3" />
    <v-layout row wrap>
      <v-flex xs12>
        <v-card>
          <v-card-title
            class="subheading font-weight-bold px-4"
          >Interventions History</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4">

            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <BarChart v-if="countryAnalytics !== null" :values="countryAnalytics.history.values" :labels="countryAnalytics.history.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by States</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="countryAnalytics !== null" :values="countryAnalytics.overview.values" :labels="countryAnalytics.overview.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>

      <v-flex xs12 sm6>
        <v-card>
          <v-card-title class="subheading font-weight-bold px-4">Interventions Overview by Agency</v-card-title>
          <!-- <v-divider></v-divider> -->
          <v-container class="px-4">
            <v-layout row wrap v-show="!analyticsLoading">
              <v-flex xs12>
                <PieChart v-if="countryAnalytics !== null" :values="countryAnalytics.overview_agency.values" :labels="countryAnalytics.overview_agency.labels" :height="150" />
              </v-flex>
            </v-layout>
            <v-layout row wrap justify-center class="pt-2 pb-5" v-show="analyticsLoading">
              <v-progress-circular
                :indeterminate="true"
                :size="24"
                :width="3"
                color="grey"
              ></v-progress-circular>
            </v-layout>
          </v-container>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import '@/plugins/google-maps'

import { AID_FETCH } from '@/store/actions/aid'
import { USER_FETCH } from '@/store/actions/user'
import { AGENCY_FETCH } from '@/store/actions/agency'
import { LOCATION_FETCH } from '@/store/actions/location'
import { EVENT_FETCH } from '@/store/actions/event'

import BarChart from '@/components/Charts/BarChart.vue'
import PieChart from '@/components/Charts/PieChart.vue'
import DateFilter from '@/components/Filters/DateFilter.vue'
import { setFormData } from '@/utils/http'
import { refineAnalytics } from '@/utils/analytics'

export default {
  name: 'AdminDashboard',
  components: {
    BarChart,
    PieChart,
    DateFilter
  },
  created () {
    this.isLoading = true
		
		Promise.all([
      this.$store.dispatch(AID_FETCH),
      this.$store.dispatch(USER_FETCH, { isAdmin: false }),
      this.$store.dispatch(AGENCY_FETCH),
      this.$store.dispatch(LOCATION_FETCH),
      this.$store.dispatch(EVENT_FETCH)
    ]).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      isLoading: false,
      analyticsLoading: false,
      countryAnalytics: null
    }
  },
  computed: {
		stats () {
			const aids = this.$store.getters.aids.length
			const events = this.$store.getters.events.length
			const locations = this.$store.getters.locations.length
			const agencies = this.$store.getters.agencies.length
			const stateStaff = this.$store.getters.agentsByParent('state').length
			const agencyStaff = this.$store.getters.agentsByParent('agency').length
			const stats = [
				{ title: 'All Events', count: events, link: '/events' },
				{ title: 'Interventions Recorded', count: aids, link: '/aids' },
        { title: 'Locations', count: locations, link: '/locations' },
        { title: 'SEMA Staff', count: stateStaff, link: '/users/agents/state' },
        { title: 'Partners', count: agencies, link: '/agencies' },
        { title: 'Partner Staff', count: agencyStaff, link: '/users/agents/agency' }
			]
			return stats
		}
  },
  methods: {
    fetchAdminAnalytics (from, to, period) {
      this.analyticsLoading = true
      this.countryAnalytics = null
      const params = setFormData({
        country_id: this.$settings.country,
        from_timestamp: from,
        to_timestamp: to,
        period: period
      })
      this.$http.post('aid/analytics_by_country', params)
        .then(({ data: response }) => {
          if (response.code === 200) {
            this.analyticsLoading = false
            // Country Analytics
            this.countryAnalytics = refineAnalytics('nema', response.data)
          }
        })
    },
    refreshAnalytics (payload) {
      this.fetchAdminAnalytics(payload.from, payload.to, payload.period)
    }
  }
}
</script>
